import * as squint_core from 'squint-cljs/core.js';
import * as str from 'squint-cljs/src/squint/string.js';
import * as clojure_DOT_string from 'squint-cljs/src/squint/string.js';
var docs_coords_path = function (p__11342) {
const map___1_3 = p__11342;
const map___1_4 = ((squint_core.truth_(squint_core.sequential_QMARK_(map___1_3))) ? (((squint_core.truth_(squint_core.vector_QMARK_(map___1_3))) ? (map___1_3) : (squint_core.seq_to_map_for_destructuring(map___1_3)))) : (map___1_3));
const _coords_5 = map___1_4;
const group_id_6 = squint_core.get(map___1_4, "group-id");
const artifact_id_7 = squint_core.get(map___1_4, "artifact-id");
const version_8 = squint_core.get(map___1_4, "version");
return `${group_id_6??''}${"/"}${artifact_id_7??''}${"/"}${version_8??''}`;

};
var docs_path = function (coords) {
return `${"/d/"}${docs_coords_path(coords)??''}`;

};
var project = function (p__11343) {
const map___1_3 = p__11343;
const map___1_4 = ((squint_core.truth_(squint_core.sequential_QMARK_(map___1_3))) ? (((squint_core.truth_(squint_core.vector_QMARK_(map___1_3))) ? (map___1_3) : (squint_core.seq_to_map_for_destructuring(map___1_3)))) : (map___1_3));
const group_id_5 = squint_core.get(map___1_4, "group-id");
const artifact_id_6 = squint_core.get(map___1_4, "artifact-id");
if (squint_core._EQ_(group_id_5, artifact_id_6)) {
return group_id_5} else {
return `${group_id_5??''}${"/"}${artifact_id_6??''}`};

};
var parse_docs_uri = function (uri) {
const vec___1_4 = str.split(uri, /\//);
const __5 = squint_core.nth(vec___1_4, 0, null);
const lead_6 = squint_core.nth(vec___1_4, 1, null);
const group_id_7 = squint_core.nth(vec___1_4, 2, null);
const artifact_id_8 = squint_core.nth(vec___1_4, 3, null);
const version_9 = squint_core.nth(vec___1_4, 4, null);
if (("d" === lead_6)) {
return ({"group-id": group_id_7, "artifact-id": artifact_id_8, "version": version_9});
};

};
var coords_from_current_loc = function () {
return parse_docs_uri(window.location.pathname);

};
var coords_path_from_current_loc = function () {
return docs_coords_path(coords_from_current_loc());

};

export { coords_path_from_current_loc, docs_coords_path, project, docs_path, coords_from_current_loc, parse_docs_uri }
